// extracted by mini-css-extract-plugin
module.exports = {"reportingPageBreak":"styles-module__reportingPageBreak___3HteW"};